export enum EXECUTION_BRIEF_HOOK {
  LANGUAGES,
  REGIONS,
  STORE_TYPES,
}
